import script from "./TicketSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketSummary.vue?vue&type=script&setup=true&lang=js"

import "./TicketSummary.vue?vue&type=style&index=0&id=73181963&lang=css"

const __exports__ = script;

export default __exports__